import React, {useState} from 'react';
import { Box, TextField, Button,Modal,CircularProgress, Typography, InputLabel } from '@mui/material';
import { useGet, usePost } from '../../hooks/useApi';
import { useParams, useLocation } from 'react-router-dom';
import PhoneInput from './PhoneInput';
import { getCountries, getCountryCallingCode } from 'libphonenumber-js';
import { handlePlaceOrder } from '../../services/api';
import { useNavigate } from 'react-router-dom';


const countryCodes = getCountries().map(country => {
  try {
    return {
      code: `+${getCountryCallingCode(country)}`,
      country: country,
    }
  } catch (error) {
    console.log(`Error with country: ${country}`, error);
    return null;
  }
}).filter(Boolean).sort((a, b) => a.code.localeCompare(b.code));


const SidebarForm = ({ setOnClose, setOpenModal, item_details}) => {
const {id} = useParams()
const [checkoutMessage, setCheckoutMessage] = useState('');
const [isLoading, setIsLoading] = useState(false);
const { data: validateCustomer} = useGet('/api/GiftItems/validate-Customer');
const [modalOpen, setModalOpen] = useState(false);
const [modalMessage, setModalMessage] = useState('');
const navigate = useNavigate();

  const customerId = validateCustomer?.data.userEmail
  console.log(customerId)


  const location = useLocation(); // Get current location (including query params)
  const queryParams = new URLSearchParams(location.search); // Create URLSearchParams object
  const productId = queryParams.get('productId');

  // const {
  //   phone,
  //   handlePhoneValueChange,
  //   inputRef,
  //   country,
  //   setCountry
  // } = usePhoneInput({
  //   defaultCountry: "us",
  //   phoneValue,
  //   countries: defaultCountries,
  //   onChange: (data) => {
  //     setPhoneValue(data.phone);
  //   }
  // });
  const [countryCode, setCountryCode] = useState('+234');
  const [phoneNumber, setPhoneNumber] = useState('');
  const handleCountryCodeChange = (value) => {
    setCountryCode(value);
    setFormData(prev => ({
      ...prev,
      phone: `${value}${phoneNumber}` // Update combined phone in formData
    }));
  };

  const handlePhoneNumberChange = (value) => {
    setPhoneNumber(value);
    setFormData(prev => ({
      ...prev,
      phone: `${countryCode}${value}` // Update combined phone in formData
    }));
  };
  // "amountPaid": 0,
  // "orderDate": "2024-12-16T14:42:04.874Z",
  // "expectedDeliveryDate": "2024-12-16T14:42:04.874Z",
  // "productId": 0,
  // "customerId": "string",
  // "orderStatus": 1,
  // "quantity": 0
    const [formData, setFormData] = useState({
        name: '',
        phone:'',
        email: '',
        instruction:'',
        address: '',
      });
      const isValid = Object.values(formData).every(field => field && field.trim() !== '');
      console.log(isValid)
      const handleChange = (event) => {
        const { name, value } = event.target; // Extract name and value from the input element
        console.log(value)
        setFormData((prevData) => ({
          ...prevData,
          [name]: value, // Dynamically update the field based on its name
  
       
       
        }));
      };
    
      // const handleSubmit = (event) => {
      //   event.preventDefault();
      //   console.log(formData);
      // };
      console.log(id)
      console.log(productId)
      const handleClick = (event) => {
        event.preventDefault();
        console.log(formData);
        setOnClose(false)      
       setOpenModal(true)
      }
     const { data: itemDetails, error: itemErr, isLoading: itemLoader} = useGet(`/api/GiftItems/get-item-details/${id?id:productId}`);
       const item = itemDetails?.data
       console.log(item)

        const { data: checkoutData, error:Err, isLoading: checkoutLoader} = usePost(`/api/GiftItemOrders/order-checkout?userId=${customerId}`);
      
      // const [trackingbarstate, setTrackingbarState] = React.useState(false);
      //   // sidebar drawer
      //   const toggleDrawer = () => (event) => {
      //       if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      //       return;
      //       }
      //       setTrackingbarState(!trackingbarstate)
      //   }
    
const orderUrl = useGet(`/api/GiftItemOrders/order-checkout?userEmail=${customerId}`)
  // const orderUrl = `https://daradservice.azurewebsites.net/api/GiftItemOrders/order-checkout?userEmail=${customerId}`;

  // Initialize the mutation hook
  // const { mutate, isLoading, isError, error, isSuccess } = usePost(url);
const orderData = {
  recipientName: formData.name,
  whatsappPhoneNumber: formData.phone,
  email: formData.email,
  specialInstructions: formData.instruction,
  deliveryAddress: formData.address,
  amountPaid: item?.price?item?.price : item?.pricePerUnit,
  orderDate: new Date().toISOString(), // Current date in ISO format
  expectedDeliveryDate: new Date(new Date().getTime() + 7 * 24 * 60 * 60 * 1000).toISOString(), // 1 week later
  productId: Number(item?.id),
  customerId: customerId?.toString(),
  orderStatus: 1,
  quantity: 1,
};
  // const handlePlaceOrder = (event) => {
  //   event.preventDefault();
  //   const payload = {
  //     recipientName: formData.name,
  //     whatsappPhoneNumber: formData.phone,
  //     email: formData.email,
  //     specialInstructions: formData.instruction,
  //     deliveryAddress: formData.address,
  //     amountPaid: item.price,
  //     orderDate: new Date().toISOString(), // Current date in ISO format
  //     expectedDeliveryDate: new Date(new Date().getTime() + 7 * 24 * 60 * 60 * 1000).toISOString(), // 1 week later
  //     productId: Number(item.id),
  //     customerId: customerId.toString(),
  //     orderStatus: 1,
  //     quantity: 1,
  //   };
  //   console.log(payload)

  //   // Trigger the mutation
  //   mutate(payload, {
  //     onSuccess: (data) => {
  //       console.log("Order placed successfully:", data);
  //       alert("Order placed successfully!");
  //     },
  //     onError: (err) => {
  //       console.log(payload)
  //       console.error("Error placing order:", err);
  //       alert("Failed to place order.");
  //     },
  //   });
  //   // setOnClose(false)      
  //   // setOpenModal(true)
  // };
  const handleCheckout = async (event) => {
    event.preventDefault();
    setIsLoading(true); 

    const orderData = {
      recipientName: formData.name,
      whatsappPhoneNumber: formData.phone,
      email: formData.email,
      specialInstructions: formData.instruction,
      deliveryAddress: formData.address,
      giftId: id ? id : productId,
    };

    console.log("Request Body:", JSON.stringify(orderData, null, 2));

    try {
      const response = await fetch('https://daradservice.azurewebsites.net/api/GiftItemOrders/order-checkout', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(orderData),
      });

      const responseData = await response.json();
      console.log("Response:", responseData);

      if (responseData.status === true) {
        setModalMessage(`Checkout successful: ${responseData.message}`);
        setModalOpen(true);
      } else {
        setModalMessage(responseData.message || 'Checkout failed.');
        setModalOpen(true);
      }
      
    } catch (error) {
      console.error('Error during checkout:', error);
      setModalMessage('An error occurred during checkout. Please try again.');
      setModalOpen(true);
    }
    finally {
      setIsLoading(false); 
    }
};



  return (
    <Box
      sx={{
        maxWidth: 400,
        margin: 'auto',
        padding: 2,
        display: 'flex',
        flexDirection: 'column',
        fontFamily: theme=> theme.typography.smallText,
        gap: 2,
      }}
    >

<div>
{checkoutMessage && (
        <div
          className="mt-4 p-4 text-white bg-green-600 rounded-md"
        >
          {checkoutMessage}
        </div>
      )}
</div>

     
<Modal
  open={modalOpen}
  onClose={() => setModalOpen(false)}
  aria-labelledby="checkout-modal"
  aria-describedby="checkout-response"
>
  <Box
    sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 300,
      bgcolor: 'background.paper',
      boxShadow: 24,
      p: 4,
      borderRadius: 2,
      textAlign: 'center'
    }}
  >
    <Typography id="checkout-modal" variant="h6" component="h2">
      {modalMessage}
    </Typography>
    <Button
  variant="contained"
  sx={{ mt: 2 }}
  onClick={() => {
    console.log('Button clicked');
    setModalOpen(false);
    setTimeout(() => {
      console.log('Navigating now...');
      navigate('/product/giftshop');
    }, 300);
  }}
>
  Okay
</Button>

  </Box>
</Modal>


      <form>


      <InputLabel sx={{textTransform: 'capitalize', fontWeight: 600}}>Your Whatsapp Number</InputLabel>
         <PhoneInput
        countryCode={countryCode}
        phoneNumber={phoneNumber}
        onCountryCodeChange={handleCountryCodeChange}
        onPhoneNumberChange={handlePhoneNumberChange}
        valid={isValid}
        countryCodes={countryCodes}
      />
        <InputLabel sx={{textTransform: 'capitalize', fontWeight: 600}}> Your Email address</InputLabel>
        
        <TextField
          hiddenLabel
     
       
          size="small"
          placeholder="@adewalemail.com" 
          variant="outlined"
          fullWidth
          name="email"
          sx={{ backgroundColor:'rgba(255, 255, 255, 1)', my:2, color: 'rgba(182, 183, 185, 1)',borderRadius: '10px'}}
          value={formData.email}
          onChange={handleChange}
       
        />
        <InputLabel sx={{textTransform: 'capitalize', fontWeight: 600}}>Recipient Name (your customer)</InputLabel>
        
        <TextField
          hiddenLabel
     
       
          size="small"
          placeholder="Enter your name" // Placeholder inside input
          variant="outlined"
          fullWidth
          name="name"
          sx={{ backgroundColor:'rgba(255, 255, 255, 1)', my:2, color: 'rgba(182, 183, 185, 1)',borderRadius: '10px'}}
          value={formData.name}
          onChange={handleChange}
       
        />


<InputLabel sx={{textTransform: 'capitalize', fontWeight: 600}}> Recipient Address (your customer)</InputLabel>
        
        <TextField
          hiddenLabel
     
       
          size="small"
          placeholder="Enter your address" 
          variant="outlined"
          fullWidth
          name="address"
          sx={{ backgroundColor:'rgba(255, 255, 255, 1)', my:2, color: 'rgba(182, 183, 185, 1)',borderRadius: '10px'}}
          value={formData.address}
          onChange={handleChange}
       
        />


        
     <InputLabel sx={{textTransform: 'capitalize', fontWeight: 600}}>Instructions</InputLabel>
        
        <TextField
          hiddenLabel
     
       
          size="small"
          placeholder="Add any special instructions" // Placeholder inside input
          variant="outlined"
          fullWidth
          name="instruction"
          sx={{ backgroundColor:'rgba(255, 255, 255, 1)', my:2, color: 'rgba(182, 183, 185, 1)',borderRadius: '10px'}}
          value={formData.instruction}
          onChange={handleChange}
       
        />
     
       
        {/* <Box sx={{backgroundColor:'rgba(252, 228, 177, 1)', my:3, p:2, borderRadius:'4px'}}>
           <Typography sx={{borderBottom:'1px solid rgba(83, 80, 92, 1)', p:2, textTransform:'capitalize', display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%'}}>
                 <span>
                     Amount to be Paid
                 </span>
                 <span>
                     ₦10,000
                 </span>
             </Typography>
             <Typography sx={{py:1, backgroundColor:'rgba(246, 167, 4, 1)', my:1, borderRadius:'4px', p:2,textTransform:'capitalize', display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%'}}>
             <span>
                 Available Balance
             </span>
             <span>
                 ₦63,234.03
             </span>
             </Typography>
         </Box> */}
    <Button
      variant="contained"
      onClick={handleCheckout}
      disabled={!isValid || isLoading} 
      sx={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        textTransform: 'none',
        '&.Mui-disabled': {
          backgroundColor: 'rgba(86, 4, 246, 0.2)',
          color: 'rgba(255, 255, 255, 1)',
        },
        color: 'rgba(255, 255, 255, 1)',
        boxShadow: 'none',
        backgroundColor: 'rgba(86, 4, 246, 1)',
        py: 1,
        px: 2,
        minWidth: 'fit-content',
        borderRadius: '100px',
        ':hover': {
          backgroundColor: '#4f03e7',
          fontWeight: 600,
          boxShadow: '0px 3px 1px -2px rgba(86, 4, 246,0.2), 0px 2px 2px 0px rgba(86, 4, 246,0.14), 0px 1px 5px 0px rgba(86, 4, 246,0.12)',
        },
      }}
    >
      {isLoading ? (
        <CircularProgress size={24} sx={{ color: 'white' }} />
      ) : (
        'Complete Checkout'
      )}
    </Button>
      </form>


      {/* <TrackingSidebar state={trackingbarstate} toggleDrawer={toggleDrawer} setTrackingbarState={setTrackingbarState}/> */}
    </Box>

  )
};    


export default SidebarForm